import * as Popover from '@radix-ui/react-popover';
import { memo } from 'react';
import { ClientOnly } from 'remix-utils/client-only';
import { CommandPopup } from '~/components/chat/commands/CommandPopup.client';

interface PromptLibraryProps {
  input: string;
  setInput: (input: string) => void;
  focusPromptInput: () => void;
}

const PromptLibrary = memo(({ input, setInput, focusPromptInput }: PromptLibraryProps) => {
  return (
    <Popover.Root open={input.startsWith('/')}>
      <Popover.Anchor
        className="absolute inset-y-0"
        style={{
          left: 'var(--chat-padding)',
          right: 'var(--chat-padding)',
        }}
      />
      <Popover.Portal>
        <Popover.Content
          onPointerDownOutside={(event) => {
            if (event.target instanceof HTMLTextAreaElement) {
              return;
            }

            event.stopPropagation();
            setInput('');
          }}
          onOpenAutoFocus={(event) => event.preventDefault()}
          side="top"
          sideOffset={8}
          className="z-10"
          style={{
            width: 'var(--radix-popper-anchor-width)',
          }}
        >
          <ClientOnly>
            {() => <CommandPopup input={input} setInput={setInput} focusPromptInput={focusPromptInput} />}
          </ClientOnly>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
});

PromptLibrary.displayName = 'PromptLibrary';

export { PromptLibrary };
